import React, { createContext, useCallback, useContext, useState } from "react";
import { isEqual, isFunction } from "lodash";
import { initialFilter } from "./PartnerQuotaUIHelpers";

const PartnerQuotaUIContext = createContext();

export function usePartnerQuotaUIContext() {
  return useContext(PartnerQuotaUIContext);
}

export const PartnerQuotaUIConsumer = PartnerQuotaUIContext.Consumer;

export function PartnerQuotaUIProvider({ partnerQuotaUIEvents, children }) {
  const [queryParams, setQueryParamsBase] = useState(initialFilter);
  const setQueryParams = useCallback((nextQueryParams) => {
    setQueryParamsBase((prevQueryParams) => {
      if (isFunction(nextQueryParams)) {
        nextQueryParams = nextQueryParams(prevQueryParams);
      }

      if (isEqual(prevQueryParams, nextQueryParams)) {
        return prevQueryParams;
      }

      return nextQueryParams;
    });
  }, []);

  const initPartnerQuota = {
    name: "",
    access: [],
  };

  const value = {
    queryParams,
    setQueryParamsBase,
    setQueryParams,
    initPartnerQuota,
    newPartnerQuotaButtonClick: partnerQuotaUIEvents.newPartnerQuotaButtonClick,
    openEditPartnerQuotaPage: partnerQuotaUIEvents.openEditPartnerQuotaPage,
  };

  return (
    <PartnerQuotaUIContext.Provider value={value}>
      {children}
    </PartnerQuotaUIContext.Provider>
  );
}
